var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',{staticClass:"d-flex content-center min-vh-100"},[_c('CRow',[_c('CCol',[_c('CCardGroup',[_c('CCard',{staticClass:"p-4"},[_c('CCardBody',[_c('CForm',[_c('h1',[_vm._v("Test")]),_c('p',{staticClass:"text-muted"},[_vm._v("Test page")]),_c('p',[_vm._v(_vm._s(_vm.items))])])],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }